import {createSlice, PayloadAction}			from '@reduxjs/toolkit';

import {NotificationCardProps}				from '../../ressources/components/NotificationCard/interface';
import {NotificationsState}					from './interface';


const initialState: NotificationsState = {
	list:   [],
	lastId: 0
};

export const Reducer = createSlice({
	name:     'notification',
	initialState,
	reducers: {
		pushNotification: (state, action: PayloadAction<NotificationCardProps>) => {
			state.lastId++;

			state.list.unshift({
				id:    state.lastId,
				icon:  action.payload.icon,
				title: action.payload.title,
				text:  action.payload.text,
				type:  action.payload.type || 'success'
			});
		},
		closeNotification: (state, action: PayloadAction<number>) => {
			const index = state.list.findIndex(find => find.id === action.payload);

			if (index !== -1)
				state.list.splice(index, 1);
		}
	}
});

export const {pushNotification, closeNotification} = Reducer.actions;

export default Reducer.reducer;
